import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-dashboard-observation-list',
  standalone: false,
  templateUrl: './dashboard-observation-list.component.html',
  styleUrls: ['./dashboard-observation-list.component.scss'],
})
export class DashboardObservationListComponent implements OnChanges {
  @Input() rows: any[] = [];
  @Input() loading = false;
  @Input() noDataText = 'No overdue observations.';

  readonly displayedColumns: string[] = ['Project', 'Name', 'Priority', 'CreatedOn', 'DueOn', 'DaysOpen', 'DaysOverdue'];
  readonly dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    if (value) {
      this.dataSource.paginator = value;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rows']) {
      this.dataSource.data = this.rows ?? [];
      this.dataSource.paginator?.firstPage();
    }
  }

  getDaysOpenClass(days: number): string {
    if (days > 14) return 'danger';
    if (days > 7) return 'warning';
    return 'ok';
  }
}
